import React from "react";
import InputMask from "react-input-mask";
import themePropTypes from "../../theme-prop-types";

const ModernizedInputField = ({
  maskingAttributes,
  fieldAttributes,
  placeholder,
  updateValue,
  onEnterDown,
  onChange,
  name,
  id,
  labelId,
  invalid,
  disabled = false,
  readOnly,
  params = "",
  isUnifiedRegistration,
  warningMessage
}) => {
  const props = {};
  if (placeholder && placeholder !== "%") {
    props.placeholder = placeholder;
  }

  const isPercentage = placeholder === "%";
  const isWarning = !!warningMessage;
  const ariaDescribedby = isUnifiedRegistration
    ? invalid
      ? `inline-error-${name}`
      : null
    : `${name}-helper-text`;

  return (
    <span
      className={
        isPercentage ? "websdk-flex" : readOnly ? "view-only-span" : ""
      }
    >
      <InputMask
        className={`modernized-input-web-sdk ${invalid ? "invalid" : ""} ${
          isWarning ? "warning" : ""
        } ${readOnly ? "view-only-input" : ""}`}
        data-testid={`modernized-input-${name}`}
        id={id || `${name}-modernized-input`}
        {...maskingAttributes}
        {...fieldAttributes}
        onBlur={updateValue}
        onKeyDown={onEnterDown}
        onChange={onChange}
        disabled={
          disabled || params.includes("TDFieldOptionDisabled") || readOnly
        }
        aria-labelledby={labelId || `${name}-label`}
        aria-invalid={invalid}
        aria-describedby={ariaDescribedby}
        {...props}
      />
      {isPercentage && (
        <span className='websdk-self-center websdk-ml-2'>%</span>
      )}
      {readOnly && <span className='view-only-icon' />}
    </span>
  );
};
ModernizedInputField.propTypes = themePropTypes.modernizedInputField;

export default ModernizedInputField;
